import { setBlockTracking as _setBlockTracking, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e08f7a10")

_pushScopeId("data-v-e08f7a10")
const _hoisted_1 = { class: "d-f mt-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _cache[1] || (
    _setBlockTracking(-1),
    _cache[1] = _createVNode("div", { class: "skeleton-sample" }, [
      (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (item) => {
        return _createVNode("div", {
          key: item,
          class: "mt-12 skeleton-bar",
          style: {height: `${_ctx.getRandomHeight}px`}
        }, null, 4)
      }), 64)),
      _createVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (item) => {
          return _createVNode("div", {
            key: item,
            class: [{[`flex-${_ctx.getRandomCol}`]: true}, "mr-16 skeleton-bar"],
            style: {"height":"10px"}
          }, null, 2)
        }), 64))
      ])
    ]),
    _setBlockTracking(1),
    _cache[1]
  )
})